import { VFC, memo } from "react";

import { shareBtns } from "components/icons";

import { signin } from "lib/signin";

import { CurrentUser } from "lib/type";

import { FaThumbsUp, FaRegThumbsUp } from "react-icons/fa";

type LikeShareProps = {
  isAuthChecking: boolean;
  user: CurrentUser;
  url: string;
  title: string;
  isCurrentLiked: boolean;
  currentLikeCount: number;
  changeLike: () => void;
};

const LikeShare: VFC<LikeShareProps> = ({
  isAuthChecking,
  user,
  title,
  url,
  isCurrentLiked,
  currentLikeCount,
  changeLike,
}) => {
  return (
    <div className="border-light-700 flex flex-col justify-end gap-6 border-t border-solid py-4">
      <dl className="flex items-center justify-end space-x-4 lg:flex-col lg:space-x-0 lg:space-y-2">
        <dt className="lg:mr-auto">記事をシェアする</dt>
        <dd className="lg:w-full">
          <ul className="flex items-center space-x-4">
            {shareBtns(url, title)}
          </ul>
        </dd>
      </dl>
      {!isAuthChecking && (
        <button
          className="ml-auto lg:ml-0"
          onClick={() => (user ? changeLike() : signin())}
        >
          {user && isCurrentLiked ? <FaThumbsUp /> : <FaRegThumbsUp />}
          <span className="ml-1">
            {currentLikeCount < 0 ? 0 : currentLikeCount}
          </span>
          {!user && (
            <span className="ml-1 text-left leading-tight lg:ml-4">
              サインインして「いいね」する
            </span>
          )}
        </button>
      )}
    </div>
  );
};

export default memo(LikeShare);
